import clearAuthSession from "../../auth/browser/clearAuthSession";
import { REFRESH_TOKEN_URL } from "../../auth/config/authConfig";
import cachedFetch from "../cachedFetch";
import defaultHeaders from "../config/defaultHeaders";

/**
 * This runs in our fetchPlus as a 'middleware'
 * if something is a 401 then we capture that and try and refresh the token and return the original response.
 * if we cant refresh, we log the user out.
 * @param response
 * @param retryCallback
 * @returns
 */
const refreshTokenFetchMiddleware = async (response: Response, retryCallback?: () => Promise<Response>) => {
    /** We only want to run this middleware if the status is a 401 */
    if (response.status !== 401) return response;

    const res = await cachedFetch(REFRESH_TOKEN_URL, {
        method: "POST",
        headers: {
            ...defaultHeaders,
        },
    });

    /** If refresh token fails then log us out */
    if (res.status !== 200) {
        clearAuthSession();
        return response;
    }

    /** If we have a retry callback, then run it and return it */
    if (retryCallback) return retryCallback();

    return response;
};

export default refreshTokenFetchMiddleware;
